export default {
    name: 'harmfulObjects',
    serverName: '/api/v1/disease/pest/',
    apiUrl: '/api/v1/disease/pest/',
    divisionUrl: '/api/v1/disease/pest_order/',
};
